function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class FetcherError extends Error {
    constructor(resp){
        super();
        _define_property(this, "name", 'FetcherError');
        _define_property(this, "response", void 0);
        this.response = resp;
    }
}

//# sourceMappingURL=error-helper.js.map